import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from 'react-i18next';

export default function VerifyAccountOtp() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation("global"); // استخدم useTranslation للترجمة

  useEffect(() => {
    localStorage.removeItem("otpAllowed");
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResend = async () => {
    setTimeLeft(60);
    setCanResend(false);
    const userData = JSON.parse(localStorage.getItem("user"));
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userData?.data?.user.email,
          }),
        }
      );
  
      const result = await response.json();
      console.log("Verify Response:", result);
  
      if (result.code === 200) {
        toast.success(t("verify2.success.otpSentAgain"), {
          autoClose: 2000,
        });
      } else {
        alert(result.message || t("verify2.errors.serverError"));
      }
    } catch (error) {
      toast.error(t("verify2.errors.serverError"));
    }
  };
  
const {i18n} = useTranslation("global");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    
    const payload = {
      otp: enteredOtp,
    };
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/confirmation-otp?otp=${enteredOtp}`, 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": i18n.language,
          },
          body: JSON.stringify(payload),
        }
      );
  
      const result = await response.json();
      console.log("API Response:", result);
  
      if (response.ok || result.code === 200) {
        toast.success(t("verify2.success.accountVerified"));
  
        setTimeout(() => {
          localStorage.removeItem("user");
          navigate("/login");
        }, 2000);
      } else {
        toast.error(result.message || t("verify2.errors.serverError"));
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error(t("verify2.errors.serverError"));
    }
  };
  
  
  
  return (
    <section style={{ backgroundColor: "#193C6E", minHeight: "100vh" }}>
      <ToastContainer />

      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img src="assets/imgs/layer 2.png" width="100%" alt="Forget Password" />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin p-4 shadow rounded-4">
              <div>
                <img src="assets/imgs/تميز copy 1.svg" alt="Taamayaz Logo" className="mb-3" />
                <h2 className="second-color ">{t("verify2.title")}</h2>
                <p className="paragraph-color ">
                  {t("verify2.description")}
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-center gap-2 mb-4">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      className="form-control"
                      style={{
                        width: "45px",
                        height: "50px",
                        fontSize: "20px",
                        border: "2px solid #6c757d",
                        borderRadius: "8px",
                      }}
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                </div>

                <button
                  type="submit"
                  style={{ backgroundColor: "#352E64", color: "#fff" }}
                  className="btn w-100 py-2 my-3"
                >
                  {t("verify2.continueBtn")}
                </button>
              </form>

              <p style={{ color: "#352E64" }} className="text-center mt-3">
                {t("otp.noCode")}{" "}
                {canResend ? (
                  <span
                    className="fw-bold"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={handleResend}
                  >
                    {t("verify2.resendOtp")}
                  </span>
                ) : (
                  <span className="fw-bold">{t("otp.wait")} : {timeLeft}</span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
